// extracted by mini-css-extract-plugin
export default {"content":"MaterialTable_content__T0C7H"};